<template>
  <div class="mainPart">
    <p class="levelFirst" v-if="userInfoMd && userInfoMd.objtype == 0">
      <span class="iconcz">
        <small>剩余激活额度（￥）</small>
        <b>{{myselfInfo.disquota | formatAmount}}</b>
      </span>
      <span class="iconxjs">
        <small>已激活扣除额度（￥）</small>
        <b>{{myselfInfo.usedisquota | formatAmount}}</b>
      </span>
    </p>
    <!--S 激活额度变更记录-->
    <ActivateRecord :isFirstLev="1"></ActivateRecord>
    <!--E 激活额度变更记录-->
  </div>
</template>
<script>
import { bus } from '@/util/bus';
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'MySelfActivateRecord',
  data () {
    return {
      userInfoMd: '', // 登录信息
      myselfInfo:{},//当前分销商信息
    }
  },
  filters: {

  },
  components: {
    ActivateRecord: resolve => require(['./ActivateRecord.vue'],resolve),//激活额度变更记录
  },
  methods: {
    //获取流向详情最新的金额信息
    viewDistributorAll() {
      api.GET_FLOWDETAIL({ flowcode: this.userInfoMd.flowcode }).then(res => {
        if (res.data.status == "200") {  
          this.myselfInfo = res.data.data;
          this.userInfoMd.disquota = this.myselfInfo.disquota;
          this.userInfoMd.usedisquota = this.myselfInfo.usedisquota;
          localStorage.setItem('userInfoMd', JSON.stringify(this.userInfoMd));
          bus.$emit('getNewUserinfo');
        } else {
          console.log("获取详情信息失败！");
        }
      });
    },
  },
  created() {
    
  },
  mounted () {
    if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!='undefined') {
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      if(this.userInfoMd.flowcode){
        this.viewDistributorAll();//获取门店信息
      }
    }
  },
  computed: {}
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
/*账户余额 一级分销商*/
.levelFirst {padding-bottom:20px;}
.levelFirst span {display: inline-block;margin-right:100px;position:relative;padding-left:60px; }
.levelFirst span:before {position: absolute; left:5px; top:5px;}
.levelFirst .iconcz:before {font-size:44px; background: linear-gradient(to bottom,#FCAA4C,#FF6C3F);-webkit-background-clip: text; background-clip: text; color: transparent;}
.levelFirst .iconxjs:before {font-size: 40px;background: linear-gradient(to bottom,#46e6f4,#409cfb);-webkit-background-clip: text; background-clip: text; color: transparent; }
.levelFirst span small{color:#999; font-size: 14px;}
.levelFirst span b {display: block; font-size: 22px; color:#000; padding-top:5px; line-height:1; font-weight:bold;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/MySelfActivateRecord.vue